import CalendarEventKeyIndex from './CalendarEventKeyIndex';
import CalendarEventsDateRangeStore from './CalendarEventsDateRangeStore';
import CalendarEventsStore from './CalendarEventsStore';
import CalendarEventsStoreIndex from './schema/CalendarEventsStoreIndex';
import CalendarFolderItemIdIndex from './CalendarFolderItemIdIndex';
import CalendarEventsCountIndex from './CalendarEventsCountIndex';
import CalendarFolderSubscriptionIndex from './CalendarFolderSubscriptionIndex';
import CalendarInfoStore from './CalendarInfoStore';
import CalendarInstanceKeyItemIdIndex from './CalendarInstanceKeyItemIdIndex';
import CalendarEventsStoreConfig from './schema/CalendarEventsStoreConfig';

let calendarEventsStore: CalendarEventsStore = null;
let calendarInfoStore: CalendarInfoStore = null;
let dateRangeStore: CalendarEventsDateRangeStore = null;
let calendarEventKeyIndex: CalendarEventKeyIndex = null;
let calendarFolderItemIdIndex: CalendarFolderItemIdIndex = null;
let calendarEventsCountIndex: CalendarEventsCountIndex = null;
let calendarInstanceKeyItemIdIndex: CalendarInstanceKeyItemIdIndex = null;
let calendarEventsStoreConfig: CalendarEventsStoreConfig = null;

export function initCalendarEventsStore() {
    calendarEventsStore = new CalendarEventsStore();
    calendarEventKeyIndex = new CalendarEventKeyIndex();
    calendarFolderItemIdIndex = new CalendarFolderItemIdIndex();
    calendarEventsCountIndex = new CalendarEventsCountIndex();
    calendarInstanceKeyItemIdIndex = new CalendarInstanceKeyItemIdIndex();
    addIndexToEventsStore(calendarEventKeyIndex);
    addIndexToEventsStore(calendarFolderItemIdIndex);
    addIndexToEventsStore(calendarInstanceKeyItemIdIndex);
    addIndexToEventsStore(calendarEventsCountIndex);
}

export function addIndexToEventsStore(storeIndex: CalendarEventsStoreIndex) {
    calendarEventsStore.addIndex(storeIndex);
}

export function initCalendarInfoStore() {
    calendarInfoStore = new CalendarInfoStore();
    calendarInfoStore.addIndex(getCalendarFolderItemIdIndex());
    calendarInfoStore.addIndex(new CalendarFolderSubscriptionIndex());
}

export function initDateRangeStore() {
    dateRangeStore = new CalendarEventsDateRangeStore();
}

export function getCalendarEventsStore(): CalendarEventsStore {
    if (calendarEventsStore == null) {
        initCalendarEventsStore();
    }
    return calendarEventsStore;
}

export function resetCalendarEventsStore() {
    calendarEventsStore && calendarEventsStore.clearStore();
}

export function getCalendarEventKeyIndex() {
    if (calendarEventKeyIndex == null) {
        initCalendarEventsStore();
    }
    return calendarEventKeyIndex;
}

export function getCalendarEventsCountIndex() {
    if (calendarEventsCountIndex == null) {
        initCalendarEventsStore();
    }
    return calendarEventsCountIndex;
}

export function getCalendarInfoStore(): CalendarInfoStore {
    if (calendarInfoStore == null) {
        initCalendarInfoStore();
    }
    return calendarInfoStore;
}

export function getDateRangeStore(): CalendarEventsDateRangeStore {
    if (dateRangeStore == null) {
        initDateRangeStore();
    }
    return dateRangeStore;
}

export function getCalendarFolderItemIdIndex(): CalendarFolderItemIdIndex {
    if (calendarFolderItemIdIndex == null) {
        initCalendarEventsStore();
    }
    return calendarFolderItemIdIndex;
}

export function getCalendarInstanceKeyItemIdIndex(): CalendarInstanceKeyItemIdIndex {
    if (calendarInstanceKeyItemIdIndex == null) {
        initCalendarEventsStore();
    }
    return calendarInstanceKeyItemIdIndex;
}

export function getStoreConfig(): CalendarEventsStoreConfig {
    return calendarEventsStoreConfig;
}

export function setStoreConfig(storeConfig: CalendarEventsStoreConfig) {
    calendarEventsStoreConfig = storeConfig;
}
